<template>
  <div class="manage-content">
    <div class="page-title mt-10">
      {{ $t('text.user_accounts') }}
    </div>
    <div class="mt-20 page-content">
      <div>
        <div class="section-title mb-20">
          <el-button
            class="save-btn mini-btn"
            type="success"
            plain
            @click="addUser()"
            v-if="p('Manage.Users.Add')"
            >{{ $t('text.add').toUpperCase() }}</el-button
          >
          <span class="right-float">
            <img src="../../assets/filter.svg" />
            <el-input
              v-model="filter"
              size="mini"
              class="search-input filter-input"
              :placeholder="$t('text.filter_by_group_or_users')"
            ></el-input>
          </span>
        </div>
        <el-table
          border
          ref="table"
          size="small"
          :data="userList"
          v-loading="loading"
          :max-height="tableHeight"
        >
          <el-table-column
            :label="$t('text.username') | firstLetterCapitalize"
            prop="user.userName"
          ></el-table-column>
          <el-table-column
            :label="$t('text.email') | firstLetterCapitalize"
            prop="user.emailAddress"
          ></el-table-column>
          <el-table-column :label="$t('text.role')">
            <template slot-scope="scope">
              <div v-if="scope.row.userRoles" class="inline-block">
                <span v-for="(userRole, i) in scope.row.userRoles" :key="i">
                  <br v-if="i !== 0" />
                  {{ userRole.roleName }}
                </span>
              </div>
              <div v-else class="inline-block">--</div>
              <!-- <span class="blue-font pointer ml-5" @click="editRole(scope.row)"
                >(<span class="underline">{{
                  $t('text.edit') | firstLetterCapitalize
                }}</span
                >)</span
              > -->
            </template>
          </el-table-column>
          <el-table-column :label="$t('text.created') | firstLetterCapitalize">
            <template slot-scope="scope">
              {{ moment(scope.row.user.createdDateTime).format('DD/MM/YY') }}
              ({{ scope.row.user.createdDiff
              }}{{ scope.row.user.createdDiffUnit }} {{ $t('text.ago') }})
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('text.status') | firstLetterCapitalize"
            width="100px"
          >
            <template slot-scope="scope">
              <span>{{
                scope.row.user.isEnabled
                  ? $t('text.active')
                  : $t('text.disabled')
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('text.password') | firstLetterCapitalize"
            v-if="p('Manage.Users.Reset Password')"
          >
            <template slot-scope="scope">
              <span
                class="blue-font pointer underline"
                @click="openResetPasswordBox(scope.row)"
                >{{ $t('text.reset_password') }}</span
              >
            </template>
          </el-table-column>
          <el-table-column
            width="140px"
            :label="$t('text.action') | firstLetterCapitalize"
            fixed="right"
            v-if="p('Manage.Users.Edit')"
          >
            <template slot-scope="scope">
              <el-button
                type="success"
                plain
                class="save-btn mini-btn min-w-80"
                @click="editUser(scope.row)"
                >{{ $t('text.edit').toUpperCase() }}</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <EditUser ref="editUser" />
    <ResetPassword ref="resetPassword" />
    <EditUserRole ref="editUserRole" />
  </div>
</template>

<script>
import swal from 'sweetalert'
import ApiService from '@/services/CommonApiService.js'
import EditUser from '@/components/manage/EditUser'
import ResetPassword from '@/components/manage/ResetPassword.vue'
import EditUserRole from '@/components/manage/EditUserRole'
import moment from 'moment'
export default {
  data() {
    return {
      moment,
      filter: '',
      userList: [],
      loading: false,
      timer: '',
      user: JSON.parse(localStorage.getItem('user')),
      tableHeight: 0
    }
  },
  components: {
    EditUser,
    ResetPassword,
    EditUserRole
  },
  mounted() {
    this.getUserList()
    this.$nextTick(() => {
      this.tableHeight =
        window.innerHeight - this.$refs.table.$el.offsetTop - 50
      let self = this
      window.onresize = function() {
        self.tableHeight =
          window.innerHeight - self.$refs.table.$el.offsetTop - 50
      }
    })
  },
  watch: {
    filter() {
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(this.getUserList, 500)
    }
  },
  methods: {
    getUserList() {
      this.loading = true
      ApiService.GetUserRoles(this.filter)
        .then(response => {
          this.loading = false
          if (response.data.success) {
            this.userList = response.data.data.map(item => {
              let createdDiff = moment().diff(
                moment(item.user.createdDateTime),
                'years'
              )
              let createdDiffUnit = 'y'
              if (createdDiff < 1) {
                createdDiff = moment().diff(
                  moment(item.user.createdDateTime),
                  'months'
                )
                createdDiffUnit = 'm'
                if (createdDiff < 1) {
                  createdDiff = moment().diff(
                    moment(item.user.createdDateTime),
                    'days'
                  )
                  createdDiffUnit = 'd'
                }
              }
              item.user.createdDiff = createdDiff
              item.user.createdDiffUnit = createdDiffUnit
              return {
                ...item
              }
            })
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.loading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    },
    addUser() {
      this.$refs.editUser.openDialog()
    },
    editUser(row) {
      this.$refs.editUser.openDialog()
      let item = {
        userId: row.user.userId,
        emailAddress: row.user.emailAddress,
        userName: row.user.userName,
        roleIds: row.userRoles.map(role => {
          return role.id
        }),
        isEnabled: row.user.isEnabled
      }
      this.$refs.editUser.form = item
    },
    openResetPasswordBox(user) {
      this.$refs.resetPassword.openDialog()
      this.$refs.resetPassword.user = JSON.parse(JSON.stringify(user.user))
    },
    editRole(user) {
      this.$refs.editUserRole.openDialog()
      this.$refs.editUserRole.user = JSON.parse(JSON.stringify(user))
    }
  }
}
</script>
